/*
 * CASA BELLA — product page helpers.
 * Listens to the theme's own "theme:variant:change" event (fired by theme.js) and
 * updates what the theme does not: the saved amount next to the sale badge and the
 * "few left" badge for the selected variant.
 */
(function () {
  if (window.cbProductInit) return;
  window.cbProductInit = true;

  function formatMoney(cents) {
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      return window.theme.formatMoney(cents, window.theme.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  document.addEventListener('theme:variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    var section = event.target.closest('[data-section-type]') || document;

    section.querySelectorAll('[data-cb-save-amount]').forEach(function (el) {
      var saved = variant.compare_at_price > variant.price ? variant.compare_at_price - variant.price : 0;
      el.textContent = saved ? formatMoney(saved) : '';
    });

    section.querySelectorAll('[data-cb-low-stock]').forEach(function (wrapper) {
      var ids = (wrapper.getAttribute('data-cb-low-stock') || '').split(',');
      var badge = wrapper.querySelector('[data-cb-low-stock-badge]');
      if (badge) badge.hidden = ids.indexOf(String(variant.id)) === -1;
    });
  });
})();

/* CASA BELLA "Comprar agora": add the selected variant to the cart, then go to checkout. */
(function () {
  if (window.cbBuyNowInit) return;
  window.cbBuyNowInit = true;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-cb-buy-now]');
    if (!btn || btn.disabled) return;
    var form = btn.closest('form');
    if (!form) return;
    event.preventDefault();

    var root = (btn.getAttribute('data-cb-buy-now') || '/').replace(/\/$/, '');
    var errors = form.querySelector('[data-cart-errors-container]');
    btn.disabled = true;
    btn.classList.add('is-loading');

    fetch(root + '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (r) {
        if (r.ok) {
          window.location.href = root + '/checkout';
          return;
        }
        if (errors) errors.textContent = (r.data && (r.data.description || r.data.message)) || '';
        btn.disabled = false;
        btn.classList.remove('is-loading');
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });

  /* Follow the add-to-cart button's availability when the variant changes */
  document.addEventListener('theme:variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    var scope = event.target.closest('[data-section-type]') || document;
    scope.querySelectorAll('[data-cb-buy-now]').forEach(function (btn) {
      btn.disabled = !variant || !variant.available;
    });
  });
})();

/* CASA BELLA "Disponível" seal next to the delivery dates: follows the selected variant; tap shows the stock note.
   This file is included more than once on the product page, so the listeners are added only once. */
(function () {
  if (window.cbAvailReady) return;
  window.cbAvailReady = true;
  document.addEventListener('theme:variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    document.querySelectorAll('[data-cb-avail]').forEach(function (el) { el.hidden = !variant || !variant.available; });
  });
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.cb-avail__btn');
    document.querySelectorAll('.cb-avail__btn[aria-expanded="true"]').forEach(function (open) {
      if (open === btn) return;
      open.setAttribute('aria-expanded', 'false');
      open.nextElementSibling.hidden = true;
    });
    if (!btn) return;
    var on = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    btn.nextElementSibling.hidden = !on;
  });
})();
